/**
 * 登录用户操作封装
 */
const userKey = 'vue_user';
export default {
    //判断是否登录
    isLogin() {
        var info = $.cookie(userKey);
        if (info == undefined)
            return false;
        return true;
    },
    //保存登录信息,后台操作
    save(info) {
        //在实际项目中后台存登录信息
        $.cookie.json = true;
        if (info.checked) {
            $.cookie(userKey, info, { path: '/', expries: 7 });
        } else {
            $.cookie(userKey, info, { path: '/' });
        }
    },
    //获取登录信息
    getInfo() {
        $.cookie.json = true; 
        var info = $.cookie(userKey);
        return info;
    },
    //判断是否是管理员角色
    isAdmin() {
        return this.getInfo().roleID == 1;
    },
    //判断是否是顾问老师
    isAdviser() {
        return this.getInfo().roleID == 3||this.getInfo().roleID == 9;
    },
    isDocument() {
        return this.getInfo().roleID == 2||this.getInfo().roleID == 8;
    },
    // 是否是文案组长（可分配/修改文案老师）
    isDocumentGroup() {
        return this.getInfo() && this.getInfo().roleID == 8;
    },
    //是否是营销老师
    isMarket() {
        return this.getInfo().roleID == 4||this.getInfo().roleID == 10;
    },
    //清空登录信息
    clear: function () {
        $.removeCookie(userKey, { path: '/' }); // => true
    },
    // 获取当前用户ID（用于判断是否本人可编辑）
    getCurrentUserID() {
        var info = this.getInfo();
        if (!info) return null;
        if (info.id != null) return info.id;
        // if (info.userID != null) return info.userID;
        // if (info.Id != null) return info.Id;
        return null;
    },
    // 留学顾问组长（可编辑本组所有留学学生）
    isAdviserGroup() {
        return this.getInfo() && this.getInfo().roleID == 9;
    },
    // 日语顾问组长（可编辑本组所有日语学生）
    isAdviserJapGroup() {
        return this.getInfo() && this.getInfo().roleID == 11;
    },
    // 日语顾问或日语顾问组长（11=组长，16=顾问），编辑日语学生时可修改顾问/营销老师
    isAdviserJapOrGroup() {
        var rid = this.getInfo() && this.getInfo().roleID;
        return rid == 11 || rid == 16;
    },
    // 教务（日语板块需有编辑权限，含顾问为空时）
    isJapEdu() {
        return this.getInfo() && this.getInfo().roleID == 23;
    },
    // 鸣野顾问（可编辑本人跟进的鸣野学生，roleID 15）
    isAdviserMingye() {
        return this.getInfo() && this.getInfo().roleID == 15;
    },
    // 鸣野营销（roleID 17）
    isMarketMingye() {
        return this.getInfo() && this.getInfo().roleID == 17;
    },
    /**
     * 留学板块：管理员 或 本板块顾问（留学顾问/组长）或 文案老师/文案组长 或 本人=该行留学顾问（营销若是本行顾问也可编辑）。
     * 文案老师、文案组长仅在留学板块几个列表有编辑权限，日语/鸣野不在此方法内。
     */
    canEditStu(row) {
        if (!row) return false;
        var info = this.getInfo();
        if (!info) return false;
        var rid = info.roleID;
        var uid = this.getCurrentUserID();
        if (rid == 1) return true; // 管理员
        if (rid == 3 || rid == 9) return true; // 本板块顾问（留学顾问/组长）可编辑
        if (rid == 2 || rid == 8) return true; // 文案老师、文案组长：留学板块列表可编辑（含 VIP），用于修改学生状态等
        if (rid == 11 || rid == 16) return true; // 日语顾问/组长
        if (rid == 15 || rid == 19) return true; // 鸣野顾问/组长：顾问不区分板块
        // 本人=该行留学顾问可编辑（含营销被选为该生顾问时）；用户 id 有效且该行留学顾问有值时才比较（该行顾问可为 null）
        if (uid != null && uid !== 0 && row.adviserID != null && row.adviserID === uid) return true;
        return false;
    },
    /**
     * 日语板块：管理员 或 教务 或 本板块顾问（日语顾问/组长）或 留学顾问/组长 或 鸣野顾问/组长 或 本人=该行顾问。
     * 顾问老师不区分板块：只要当前用户是顾问（留学/日语/鸣野）或当前用户是该行顾问即展示编辑。
     */
    canEditJap(row) {
        if (!row) return false;
        var info = this.getInfo();
        if (!info) return false;
        var rid = info.roleID;
        var uid = this.getCurrentUserID();
        if (rid == 1) return true; // 超级管理员
        if (rid == 12 || rid == 23) return true; // 教务：日语所有列表可编辑
        if (rid == 11 || rid == 16) return true; // 日语顾问/组长
        if (rid == 3 || rid == 9) return true;   // 留学顾问/组长：顾问不区分板块
        if (rid == 15 || rid == 19) return true; // 鸣野顾问/组长：顾问不区分板块
        if (uid != null && uid !== 0 && (row.adviserID === uid || (row.jpAdviserID != null && row.jpAdviserID === uid))) return true;
        return false;
    },
    /**
     * 鸣野板块：管理员 或 本板块顾问（鸣野顾问/组长）或 本人=该行鸣野顾问（营销若是本行顾问也可编辑）。
     */
    canEditMingye(row) {
        if (!row) return false;
        var info = this.getInfo();
        if (!info) return false;
        var rid = info.roleID;
        var uid = this.getCurrentUserID();
        if (rid == 1) return true;
        if (rid == 15 || rid == 19) return true; // 本板块顾问
        if (rid == 11 || rid == 16) return true; // 日语顾问/组长
        if (rid == 3 || rid == 9) return true;   // 留学顾问/组长：顾问不区分板块
        // 用户 id 有效且该行鸣野顾问有值且等于本人（该行顾问可为 null）
        if (uid != null && uid !== 0 && row.myAdviserID != null && row.myAdviserID === uid) return true;
        return false;
    },
    /**
     * 统一资源列表：是否可编辑（任一板块可编辑即可）
     */
    canEditAny(row) {
        return this.canEditStu(row) || this.canEditJap(row) || this.canEditMingye(row);
    },
    /**
     * 留学列表：当前用户是该行留学营销且不是该行留学顾问（跨部门分配导致）→ 仅查看详情+分配，无编辑/评估表。
     * 超级管理员不视为「仅营销」：管理员＞营销角色，自己录入且营销为自己时仍显示编辑。
     */
    isMarketingOnlyStu(row) {
        if (!row) return false;
        if (this.isAdmin()) return false; // 超级管理员始终有完整操作，不受营销限制
        var uid = this.getCurrentUserID();
        if (!uid) return false;
        return row.marketID == uid && row.adviserID != uid;
    },
    /**
     * 日语列表：当前用户是该行日语营销且不是该行日语顾问 → 仅查看详情+分配。管理员不受限。
     */
    isMarketingOnlyJap(row) {
        if (!row) return false;
        if (this.isAdmin()) return false;
        var uid = this.getCurrentUserID();
        if (!uid) return false;
        var jpMarket = row.jpMarketID != null ? row.jpMarketID : row.marketID;
        var jpAdviser = row.jpAdviserID != null ? row.jpAdviserID : row.adviserID;
        return jpMarket == uid && jpAdviser != uid;
    },
    /**
     * 鸣野列表：当前用户是该行鸣野营销且不是该行鸣野顾问 → 仅查看详情+分配。管理员不受限。
     */
    isMarketingOnlyMingye(row) {
        if (!row) return false;
        if (this.isAdmin()) return false;
        var uid = this.getCurrentUserID();
        if (!uid) return false;
        return row.myMarketID == uid && row.myAdviserID != uid;
    },
    /**
     * 留学列表：该行留学顾问为空 → 仅显示查看+分配，不能编辑
     */
    isNoAdviserStu(row) {
        if (!row) return false;
        var id = row.adviserID != null ? row.adviserID : row.adviserId;
        return id == null || id === 0 || id === '';
    },
    /**
     * 日语列表：该行日语顾问为空 → 仅显示查看+分配（管理员、教务不受限，仍显示编辑）
     */
    isNoAdviserJap(row) {
        if (!row) return false;
        var id = row.jpAdviserID != null ? row.jpAdviserID : row.adviserID;
        return id == null || id === 0 || id === '';
    },
    /**
     * 日语列表：是否只显示查看+分配。管理员、教务看第二套完整按钮；营销/无顾问只看第一套。
     */
    showLimitedOpJap(row) {
        if (!row) return false;
        if (this.isAdmin() || this.isJapEdu()) return false;
        return this.isMarketingOnlyJap(row) || this.isNoAdviserJap(row);
    },
    /**
     * 鸣野列表：该行鸣野顾问为空 → 仅显示查看+分配（管理员不受限，仍显示编辑；鸣野无教务）
     */
    isNoAdviserMingye(row) {
        if (!row) return false;
        var id = row.myAdviserID != null ? row.myAdviserID : row.myAdviserId;
        return id == null || id === 0 || id === '';
    },
    /**
     * 鸣野列表：是否只显示查看+分配。管理员即使顾问为空也显示完整操作。
     */
    showLimitedOpMingye(row) {
        if (!row) return false;
        if (this.isAdmin()) return false;
        return this.isMarketingOnlyMingye(row) || this.isNoAdviserMingye(row);
    },
    /**
     * 统一资源列表：该学生在所有已分配板块下顾问均为空 → 仅显示查看+分配
     */
    isAllAssignedNoAdviser(row) {
        if (!row) return false;
        var stuOk = !row.isStudent || this.isNoAdviserStu(row);
        var japOk = !row.isJap || this.isNoAdviserJap(row);
        var mingyeOk = !row.isMingye || this.isNoAdviserMingye(row);
        return stuOk && japOk && mingyeOk;
    }
}